module.exports = __webpack_public_path__ + "static/media/calendar.782ffb1d.svg";